var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticClass:"h-100",attrs:{"show":_vm.loading,"rounded":"sm"}},[_c('div',{staticClass:"card mb-0 h-100"},[_c('div',{staticClass:"card-body d-flex justify-content-center align-items-center"},[_c('Chart',{ref:"chart",attrs:{"height":"400","type":"pie","series":_vm.chartSeries,"options":_vm.chartOptions}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }